import {ApiRequest, ApiResponse} from "@gongt/ts-stl-library/request/protocol";
import {ERequestType} from "@gongt/ts-stl-library/request/request";
import {IUserDataNormalizedClient, IUserProfileBase} from "../define";

export const GetCurrentUserUrl = `/get_current_user`;
export const GetCurrentUserMethod = ERequestType.TYPE_GET;

export interface GetCurrentUserRequest extends ApiRequest {
	token: string;
}

export interface GetCurrentUserResponse<IProfile extends IUserProfileBase> extends ApiResponse {
	user: IUserDataNormalizedClient<IProfile>;
	token: string;
}
